import { h } from 'vue';
import { HorizontalBar } from 'vue-chartjs';
import merge from 'deepmerge';

export default {
  extends: HorizontalBar,
  props: ['chartData', 'options'],

  computed: {
    barOptions() {
      return merge.all([
        this.options || {},
        {
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                barPercentage: 0.6,
                categoryPercentage: 1.0,
              },
            ],
            xAxes: [
              {
                ticks: {
                  min: 0,
                  max: 100,
                  callback(value) {
                    return `${value}%`;
                  },
                },
              },
            ],
          },
        },
      ]);
    },
  },

  render() {
    return h('div', { style: this.styles, class: this.cssClasses }, [
      h('canvas', {
        id: this.chartId,
        width: this.width,
        height: this.height,
        ref: 'canvas',
      }),
    ]);
  },

  mounted() {
    this.renderChart(this.chartData, this.barOptions);
  },
};
